import { cn } from '@seen/ui'
import type { JSX } from 'react'

export function IconOpenInWindow({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.495 5.25a.75.75 0 1 0 1.5 0V4.5a2.5 2.5 0 0 0-2.5-2.5H3.5A2.5 2.5 0 0 0 1 4.5v7A2.5 2.5 0 0 0 3.499 14h.75a.75.75 0 0 0 0-1.5h-.75a1 1 0 0 1-1-1V5h10.996v.25ZM3.999 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0-.001-1 .5.5 0 0 0 0 1Zm2.498-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
      <path d="M12.19 7.038a.31.31 0 0 1 .36.045l2.322 2.361a.407.407 0 0 1 .016.575L12.55 12.7a.324.324 0 0 1-.229.098c-.188 0-.34-.169-.34-.377v-1.41c-4.198.185-5.298 2.634-5.304 2.672-.027.183-.17.317-.337.317h-.027c-.178-.016-.314-.18-.313-.378 0-.064.605-4.634 5.998-4.886V7.379c0-.145.075-.278.193-.34Z" />
    </svg>
  )
}
